export function trackOpenQuickSearchModal(): void {
  if (window.heap) {
    window.heap.track('Hotkey used', {
      hotkey: 'cmd+j',
      userAction: 'Open Search Modal',
      context: window.location.pathname,
    })
  }
}
